module.exports = __webpack_public_path__ + "img/lg_ring_r_0_0_null.b9d34dd8.png";